var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error"},[_c('div',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.error.message))]),_vm._v(" "),_c('NuxtLink',{attrs:{"to":"/","title":"展会网"}},[_vm._v("<返回首页")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }